import DOMPurify from "dompurify";

export const HTML_RE = /<\/?(?:blockquote|colgroup|strong|tbody|thead|table|code|mark|span|div|img|pre|col|em|h[1-4]|hr|li|ol|ul|tr|th|td|br|p|b|i|u|s|a)\b[^<>]*>/i;

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener noreferrer");
  // Large custom font sizes shrink on small screens (e.g. 48px → ~31px on a phone)
  const px = parseFloat(node.style?.fontSize);
  if (node.style?.fontSize?.endsWith("px") && px > 20) {
    node.style.fontSize = `clamp(18px, ${(px / 6).toFixed(2)}vw, ${px}px)`;
  }
});

export const isRichHtml = (v) => typeof v === "string" && HTML_RE.test(v);

const IFRAME_OK = /^https:\/\/(www\.youtube(-nocookie)?\.com\/embed\/|player\.vimeo\.com\/video\/|drive\.google\.com\/file\/d\/)/;
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName === "iframe" && !IFRAME_OK.test(node.getAttribute("src") || "")) node.parentNode?.removeChild(node);
});
export const sanitizeHtml = (html) => DOMPurify.sanitize(html, { ADD_TAGS: ["iframe"], ADD_ATTR: ["target", "allowfullscreen", "frameborder", "data-youtube-video"] });

export const htmlToText = (v) => {
  if (!isRichHtml(v)) return v || "";
  const div = document.createElement("div");
  div.innerHTML = sanitizeHtml(v.replace(/<br\s*\/?>/gi, " ").replace(/<\/(p|h[1-6]|li|div|td|th|tr)>/gi, "$& "));
  return div.textContent.replace(/\s+/g, " ").trim();
};

// Renders admin-authored rich text; plain text (legacy values) renders as-is.
export const RichText = ({ html, inline = false, className = "", ...rest }) => {
  const Tag = inline ? "span" : "div";
  if (!isRichHtml(html)) {
    return <Tag className={`${inline ? "" : "whitespace-pre-line"} ${className}`} {...rest}>{html}</Tag>;
  }
  return (
    <Tag
      className={`${inline ? "rich-inline" : "rich-content"} ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      {...rest}
    />
  );
};
